module.exports = __webpack_public_path__ + "static/img/ubo_logo.8a3adaff.png";